import { liveElement } from '@the-shared/live-element';

export function viewActivation(
	callback: Function,
	selectorOrElement: string | HTMLElement,
	autoStartTimeOut = 0,
	force = false,
	rootMargin = '600px 0px 600px 0px',
	threshold = [ 0.01 ]
) {
	return new Promise( async ( resolve, reject ) => {
		if ( force ) {
			try {
				resolve( await callback() );
			} catch ( e ) {
				reject( e );
			}
			return;
		}

		let intersectionObserverInit = false;
		let autoStartTimeOutId: number | null = null;

		const observer = new IntersectionObserver(
			( [ entry ] ) => {
				if ( intersectionObserverInit || entry.isIntersecting ) {
					runCallback();
				} else {
					intersectionObserverInit = true;
				}
			},
			{
				rootMargin,
				threshold,
			}
		);

		let liveElementDisconnect: () => void = () => null;
		if ( typeof selectorOrElement === 'string' ) {
			liveElementDisconnect = liveElement< HTMLDivElement >(
				selectorOrElement,
				( element ) => {
					observer.observe( element );
				}
			);
		} else {
			observer.observe( selectorOrElement );
		}

		async function runCallback() {
			if ( autoStartTimeOutId ) {
				clearTimeout( autoStartTimeOutId );
			}

			observer.disconnect();
			liveElementDisconnect();

			try {
				resolve( await callback() );
			} catch ( e ) {
				reject( e );
			}
		}

		if ( autoStartTimeOut ) {
			autoStartTimeOutId = window.setTimeout(
				runCallback,
				autoStartTimeOut
			);
		}
	} );
}
